export default __webpack_public_path__ + "static/media/img-1.d0b489cb.png";